import * as XLSX from "xlsx";

const safe = (value) => {
  const text = String(value ?? "");
  return /^[=+@\-\t\r]/.test(text) ? `\'${text}` : text;
};

export function downloadTransferExcel(rows, dateFrom, dateTo) {
  const columns = ["ID TRASLADO", "ORIGEN", "DESTINO", "SOLICITANTE", "ESTADO", "FECHA", "TIPO GUÍA", "NÚMERO GUÍA", "IMEI", "PRODUCTO", "MODELO"];
  const values = (rows || []).map((r) => [r.transferId,r.origin,r.destination,r.requester,r.status,
    r.createdAt ? String(r.createdAt).replace("T", " ").slice(0,19) : "",
    r.guideType,r.guideNumber,r.imei,r.product,r.model].map(safe));
  const sheet = XLSX.utils.aoa_to_sheet([columns,...values]);
  sheet['!cols'] = [29,28,28,28,24,22,20,24,23,42,32].map((wch) => ({wch}));
  sheet['!autofilter'] = {ref: `A1:K${values.length + 1}`};
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook,sheet,"Traslados");
  XLSX.writeFile(workbook,`Traslados_${dateFrom}_al_${dateTo}.xlsx`);
}
